import { MouseEvent, ReactNode, useState } from "react";

import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";

export interface IRowMenuItem {
  func: () => void;
  label: ReactNode;
}

interface IRowActionsMenuProperties {
  rowMenuItems: IRowMenuItem[];
}

interface IRowActionsMenuItemProperties {
  closeMenu: () => void;
  item: IRowMenuItem;
}

const RowActionsMenuItem = ({ closeMenu, item }: IRowActionsMenuItemProperties) => {
  const handleClick = () => {
    closeMenu();
    item.func();
  };

  return <MenuItem onClick={handleClick}>{item.label}</MenuItem>;
};

export default function RowActionsMenu({ rowMenuItems }: IRowActionsMenuProperties) {
  const [anchorElement, setAnchorElement] = useState<HTMLButtonElement | null>(null);

  return (
    <Box>
      <Tooltip title="View actions">
        <IconButton
          disableRipple
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            setAnchorElement(event.currentTarget);
          }}
        >
          <MoreVertRoundedIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
        onClose={() => setAnchorElement(null)}
        open={Boolean(anchorElement)}
        transformOrigin={{
          horizontal: "left",
          vertical: "top",
        }}
      >
        {rowMenuItems.map((item, index) => (
          <RowActionsMenuItem closeMenu={() => setAnchorElement(null)} item={item} key={index} />
        ))}
      </Menu>
    </Box>
  );
}
